
export default {
  name: 'month-upload',
  props: {
    value: { type: Boolean, default: false },
    live: { type: Boolean, default: true },
    hint: { type: String, default: 'アップロードする記事の<br>時期を選択してください' },
    pubType: { type: String, default: '' },
    landlordId: { type: [Number, String], default: 0 },
    requireAvailable: { type: Boolean, default: false }
  },
  data: function () {
    var d = new Date();
    var y = d.getFullYear();
    return {
      year: y,
      month: d.getMonth() + 1,
      nowYear: y,
      fileMap: {},
      listLoaded: false
    };
  },
  computed: {
    opened: function () {
      return this.value;
    },
    yearOptions: function () {
      var now = this.nowYear;
      var set = {};
      var y;
      var keys;
      var i;
      var yr;
      for (y = now - 3; y <= now + 1; y++) {
        set[y] = true;
      }
      keys = Object.keys(this.fileMap);
      for (i = 0; i < keys.length; i++) {
        yr = parseInt(String(keys[i]).split('-')[0], 10);
        if (isFinite(yr)) set[yr] = true;
      }
      return Object.keys(set).map(function (k) {
        return parseInt(k, 10);
      }).sort(function (a, b) {
        return a - b;
      });
    },
    emptyPublished: function () {
      return this.requireAvailable && this.listLoaded && !this.hasAnyFile;
    },
    hasAnyFile: function () {
      return Object.keys(this.fileMap || {}).length > 0;
    }
  },
  watch: {
    opened: function (v) {
      if (v) this.onOpen();
    }
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastMock: function () {
      this.toast('mock：未接线');
    },
    shiftYear: function (delta) {
      var next = Number(this.year) + delta;
      if (!isFinite(next) || next < 2000 || next > 2100) return;
      this.year = next;
    },
    monthKey: function (year, month) {
      return String(year) + '-' + String(month);
    },
    hasFile: function (m) {
      return !!this.fileMap[this.monthKey(this.year, m)];
    },
    onOpen: function () {
      this.fileMap = {};
      this.listLoaded = false;
      if (!this.live) {
        this.listLoaded = true;
        return;
      }
      if (this.pubType) {
        this.loadList();
        return;
      }
      if (this.landlordId) {
        this.loadPublished();
        return;
      }
      this.listLoaded = true;
    },
    applyMonthItems: function (items) {
      var map = {};
      var i;
      var it;
      var y;
      var m;
      items = items || [];
      for (i = 0; i < items.length; i++) {
        it = items[i];
        y = parseInt(it.year, 10);
        m = parseInt(it.month, 10);
        if (!isFinite(y) || !isFinite(m)) continue;
        if (this.pubType && !it.id && !it.file_url) continue;
        var key = this.monthKey(y, m);
        if (!map[key]) map[key] = it.id || 1;
      }
      this.fileMap = map;
      this.listLoaded = true;
    },
    loadList: function () {
      var t = this;
      axios.get('landlord/publication', { params: { type: this.pubType } }).then(function (res) {
        var items = [];
        if (res.data && res.data.status == 1 && res.data.options && res.data.options.items) {
          items = res.data.options.items;
        }
        t.applyMonthItems(items);
      }).catch(function () {
        t.listLoaded = true;
        t.toast('読み込みに失敗しました');
      });
    },
    loadPublished: function () {
      var t = this;
      axios.get('settlement/publishedMonths', {
        params: { landlord_id: this.landlordId }
      }).then(function (res) {
        var items = [];
        if (res.data && res.data.status == 1 && res.data.options && res.data.options.items) {
          items = res.data.options.items;
        }
        t.applyMonthItems(items);
      }).catch(function () {
        t.listLoaded = true;
        t.toast('読み込みに失敗しました');
      });
    },
    close: function () {
      this.$emit('input', false);
    },
    onOk: function () {
      if (this.requireAvailable && !this.hasFile(this.month)) {
        this.toast('まだ公開されていません');
        return;
      }
      this.$emit('picked', { year: this.year, month: this.month });
      this.close();
      if (!this.live) this.toastMock();
    },
    onCancel: function () {
      this.close();
    }
  }
};
